module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_3.3de5960f.jpeg";